import { Component } from '@angular/core';
import { observeParam } from '@suvo/frontend/standalone/router/params';
import type { TowSamplesData } from '../../../resolvers/tow-samples.resolver';

@Component({
  selector: 'app-sample-data-entry-sample-switcher',
  template: `
    <button mat-button [matMenuTriggerFor]="menu">Switch Sample</button>
    <mat-menu #menu="matMenu">
      @if (currentSampleID | async; as currentSampleID) {
        @if ((samples | async)?.(); as samples) {
          @for (sample of samples; track $index) {
            @if (sample._id !== currentSampleID) {
              <!-- This was changed to href instead of routerLink as a quick fix at some point as the reactivity was not fully working. -->
              <a
                mat-menu-item
                [href]="'tows/' + sample.towId + '/samples/' + sample._id"
                [style.opacity]="sample.submittedAt ? '50%' : '100%'"
              >
                <div style="display: flex; align-items: center; gap: 16px">
                  <app-user-avatar [userId]="sample.userId" [showLabel]="false" />
                  <span>{{ sample.sampleNo }}</span>
                </div>
              </a>
            }
          }
        }
      }
    </mat-menu>
  `,
})
export class DataEntrySampleSwitcherComponent {
  readonly currentSampleID = observeParam('route', 'sampleID');
  readonly samples = observeParam<TowSamplesData>('data', 'samples');
}
